<!-- 异常记录详细 -->
<template>
  <div>
    <modal :visible.sync='visible' :title="$t('integration.abnormal_record_details')" width='600px' append-to-body>
      <div class='pd-5'>
        <el-form label-width="120px" label-position="right">
          <el-form-item :label="$t('integration.ir_belonging_to')">
            {{ exDetail.fullPath }}
          </el-form-item>
          <el-form-item :label="$t('integration.monitoring_point')">
            {{ exDetail.carrierName }}
          </el-form-item>
          <el-form-item :label="$t('integration.ir_installation_point')">
            {{ exDetail.carrierDeviceName }}
          </el-form-item>
          <el-form-item :label="$t('integration.type')">
            {{ exType[exDetail.exCatalog] && $t(alarmReason[exDetail.exCatalog].title) }}
          </el-form-item>
          <!-- 添加消息类型 -->
          <el-form-item v-if="fromInvalid" :label="$t('integration.notice_type')">
            <el-select v-model="type">
              <el-option
                v-for="item in invalidMsg"
                :key="item.value"
                :label="$t(item.label)"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('integration.ir_abnormal_time')">
            {{ $timetransition(exDetail.happenTime) }}
          </el-form-item>
          <el-form-item :label="$t('integration.ir_close')">
            {{ exDetail.status ?  $t('public.yes') : $t('public.no') }}
          </el-form-item>
          <el-form-item :label="$t('integration.ir_processing_results')">
            {{ exDetail.processResult }}
          </el-form-item>
          <el-form-item :label="$t('integration.remarks')">
            {{ exDetail.processRemark }}
          </el-form-item>
          <el-form-item :label="$t('integration.closing_time')">
            {{ $timetransition(exDetail.closeTime) }}
          </el-form-item>
          <el-form-item :label="$t('integration.duration')">
            {{ timeInterval(exDetail.happenTime, exDetail.closeTime) }}
          </el-form-item>
        </el-form>

        <div class='uk-position-relative'>
          <el-tabs type='card' v-model='tab'>
            <el-tab-pane :label="$t('integration.ir_abnormal_record')" name='ExRecord'></el-tab-pane>
            <el-tab-pane :label="$t('integration.ir_processing_records')" name='HandleRecord'></el-tab-pane>
          </el-tabs>
          <el-button class='btn-handle' type='primary' @click='handle'>{{ $t('integration.handle') }}</el-button>
        </div>
        <div>
          <component :is='tab' :exId='exDetail.id' ref='records'></component>
        </div>
      </div>

      <div v-if="fromInvalid" slot="footer">
        <el-button type="primary" @click="visible = false">{{ $t('public.btn_cancel') }}</el-button>
        <el-button type="primary" @click="handleSave">{{ $t('integration.ir_application') }}</el-button>
      </div>

    </modal>
    <HandleExDia :exId='exDetail.id'></HandleExDia>

  </div>
</template>

<script>
import bus from '@/utils/bus'
import ExRecord from './component/ExRecord.vue'
// import HandleRecord from './component/HandleRecord.vue'
// 改成新的记录组件
import HandleRecord from '@/pages/abnormal/invalidRule/handle/HandleRecord.vue'
import HandleExDia from '@/pages/abnormal/component/HandleExDia/HandleExDia'
import { exDetail, markExRecord } from '@/api/modules/abnormal'
import { timeInterval } from '@/utils/time'
import { invalidMsg, alarmReason } from '@/utils/convert.js'

export default {
  props: {
    // 无效异常功能要求在异常详情添加消息类型，添加一个prop区别原来的和无效异常
    fromInvalid: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    ExRecord,
    HandleRecord,
    HandleExDia
  },
  data () {
    return {
      visible: false,
      tab: 'ExRecord',
      exDetail: {},
      invalidMsg,
      type: null,
      alarmReason
    }
  },
  computed: {
    timeInterval: () => timeInterval,
    exType () {
      return this.$store.state.exType
    }
  },
  mounted () {
    bus.$on('exDetail', ({ id }) => {
      if (!id) {
        return
      }

      console.log('--', this.fromInvalid)
      this.visible = true
      this.$set(this.exDetail, 'id', id)
      exDetail(id).then(({ result }) => {
        this.exDetail = result
        // 将excludeStatus的格式转换一下
        if(result.excludeStatus === 0){
          this.type = 'normal'
        }else if(result.excludeStatus === 1){
          this.type = 'abnormal'
        }else if(result.excludeStatus === 2){
          this.type = 'suspecte'
        }else{
          this.type = null
        }
      })
    })
  },
  beforeDestroy () {
    bus.$off('exDetail')
  },
  methods: {
    handle () {
      bus.$emit('handleEx', {
        detail: [this.exDetail],
        callback: () => {
          if (this.tab == 'HandleRecord') {
            this.$refs.records.getListFn()
          }
        }
      })
    },
    handleSave(){
      if(!this.type){
        this.$message.warning(this.$t('public.please') + this.$t('integration.notice_type'))
        return
      }
      markExRecord(this.type, this.exDetail.id).then(({state}) => {
        if (state.code === 200) {
          this.$message.success($t('integration.success'))
          this.visible = false
          this.$parent.getList()
        }
      })
    }
  }
}
</script>

<style scoped lang='scss'>
::v-deep .el-tabs__item {
  padding: 0 13px !important;
}

.btn-handle {
  position: absolute;
  right: 0;
  top: 5px;
}

</style>
